import React from "react";

function DiopterImages({ diopterValue }) {
  return (
    <img
      src={`diopters/myopia-simulator-${diopterValue}D.gif`}
      alt={`Uncorrected vision at Rx level -${diopterValue}`}
      height="auto" width="auto"
    />
  );
}
export default DiopterImages;
